import {
  ADDABLE_BLOCK_KINDS,
  FIXED_BLOCK_KINDS
} from '@/types/gamificationPageBlock'
import type {
  GamificationBlockClass,
  GamificationBlockEmptyPolicy,
  GamificationBlockKind
} from '@/types/gamificationPageBlock'

/**
 * Espelho de `GamificationPageBlock::REGISTRY` (api) e do registry do webapp.
 * O teste de contrato compara os três — alterar aqui exige alterar lá.
 *
 * `requires` é o `module_type` de `GamificationPage` do qual o bloco depende:
 * com o módulo desativado no menu, o bloco não renderiza para o participante.
 */
export interface BlockRegistryEntry {
  kind: GamificationBlockKind
  blockClass: GamificationBlockClass
  emptyPolicy: GamificationBlockEmptyPolicy
  requires: string | null
}

export const BLOCK_REGISTRY: Record<GamificationBlockKind, BlockRegistryEntry> = {
  quest_book: { kind: 'quest_book', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: null },
  objectives: { kind: 'objectives', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: null },
  ranking: { kind: 'ranking', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: null },
  medals: { kind: 'medals', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: null },
  missions: { kind: 'missions', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: 'missions' },
  schedule: { kind: 'schedule', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: 'schedule' },
  social_feed: { kind: 'social_feed', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: 'forum' },
  partners: { kind: 'partners', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: null },
  matchmaking: { kind: 'matchmaking', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: 'matchmaking' },
  shop: { kind: 'shop', blockClass: 'fixed', emptyPolicy: 'placeholder', requires: 'rewards' },
  banner: { kind: 'banner', blockClass: 'addable', emptyPolicy: 'hide', requires: null },
  rich_text: { kind: 'rich_text', blockClass: 'addable', emptyPolicy: 'hide', requires: null },
  embed: { kind: 'embed', blockClass: 'addable', emptyPolicy: 'hide', requires: null },
  cta: { kind: 'cta', blockClass: 'addable', emptyPolicy: 'hide', requires: null },
  section_title: { kind: 'section_title', blockClass: 'addable', emptyPolicy: 'hide', requires: null }
}

export const isKnownBlockKind = (kind: string): kind is GamificationBlockKind =>
  Object.prototype.hasOwnProperty.call(BLOCK_REGISTRY, kind)

export const getBlockRegistryEntry = (
  kind: string
): BlockRegistryEntry | null => (isKnownBlockKind(kind) ? BLOCK_REGISTRY[kind] : null)

export { ADDABLE_BLOCK_KINDS, FIXED_BLOCK_KINDS }
